import { BaseLayout } from "@layouts/index";

import { PropertyCardList } from "@lists/PropertyCardList";
import { createSearchParams, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";

import { getProperties, getPropertyKinds } from "@services/krent.service";
import {
  PropertyListResponse,
  PropertySummaryResponse,
} from "@interfaces/properties.interface";
import { BaseApiResponse, PaginatedResponse } from "@interfaces/app.interface";

import { NewsListResponse } from "@interfaces/news.interface";
import { addPageToSessionStorage } from "@utils/helpers";
import GetMeta from "@pages/SeoPages/GetMeta";

import LeaseConfidenceSection from "components/LandingPage/more-hero";
import PropertyFeaturedSection from "components/LandingPage/property-featured-section";
import PropertyFeaturedFormSection from "components/LandingPage/property-featured-form-section";
import WhatWeOfferSection from "components/LandingPage/what-we-offer-section";
import MediaFaqSection from "components/LandingPage/media-faq-section";

export const More = () => {
  const [loading, setLoading] = useState<boolean>(false);

  const [properties, setProperties] = useState<PropertyListResponse[]>([]);
  const [news, setNews] = useState<NewsListResponse[]>([]);

  const navigate = useNavigate();

  const handleSearchTab = (int: any) => {
    let params: URLSearchParams = new URLSearchParams();
    if (int) params.append("intent", int);
    addPageToSessionStorage(1);

    navigate(
      {
        pathname: "/explore/",
        search: `?${createSearchParams(params)}`,
      },
      { replace: false },
    );
  };

  useEffect(() => {
    setLoading(true);
    let abortController = new AbortController();
    getProperties({}, abortController.signal)
      .then(
        (
          res: BaseApiResponse<
            PropertyListResponse[],
            PaginatedResponse,
            PropertySummaryResponse
          >,
        ) => {
          setProperties(res.data);
        },
      )
      .catch(() => {})
      .finally(() => {
        setLoading(false);
      });

    return () => {
      abortController.abort();
    };
  }, []);

  useEffect(() => {
    let abortController = new AbortController();
    getPropertyKinds(abortController.signal)
      .then(() => {})
      .catch(() => {})
      .finally(() => {});

    return () => {
      return abortController.abort();
    };
  }, []);

  useEffect(() => {
    let abortController = new AbortController();

    const nNews = async () => {
      const url = process.env["REACT_APP_BLOG_BASE_URL"];

      try {
        const res = await fetch(`${url}`);
        let result = await res.json();
        setNews(result);
        return result;
      } catch (error) {
        console.log(error);
      }
    };
    nNews();
    return () => {
      abortController.abort();
    };
  }, []);

  return (
    <BaseLayout news={news} handleSearchTab={handleSearchTab}>
      <GetMeta
        description="Krent is a real estate and property listing website in Nigeria. Find homes to buy or rent from trusted landlords and agents. Sell your property or find a new home easily with our wide selection of flats, apartments, houses, and more"
        canonicalValue=" "
      />
      <LeaseConfidenceSection />
      <PropertyFeaturedSection />
      <WhatWeOfferSection />

      <section className="container ">
        <h4 className="mb-4 text-grayish font-onest fw-semibold ">
          See the Difference -{" "}
          <span className="text-primary">Why Owners Choose Krent</span>
        </h4>
        <PropertyCardList
          properties={properties}
          loading={loading}
          items={6}
          showBtn
        />
      </section>

      <PropertyFeaturedFormSection />
      <MediaFaqSection />

      {/* {news.length > 0 ? (
        <div
          className="position-fixed  "
          style={{
            bottom: "40%",
            right: `${adRight}rem`,
            zIndex: "99",
            background: "#282626",
            width: "18.75rem",
            height: "8.125rem",
            transition: "all 1s ease-in-out",
          }}
        >
          <AdModal news={news} />
          <span
            className="position-absolute "
            style={{
              top: "-10px",
              left: "-5px",
            }}
            onClick={() => {
              setAdRight(-50);
            }}
          >
            <i className="fa fa-x border border-secondary fs-8 p-1  rounded-pill bg-white text-dark-black cursor-pointer"></i>
          </span>
        </div>
      ) : (
        <span></span>
      )}
      <div
        className={`bg-primary position-fixed px-2 text-white cursor-pointer `}
        style={{
          height: "5rem",
          width: "1.5rem",
          bottom: "1rem",
          transition: "all 1s ease-in-out",
          right: ` ${adRight === 0 ? "-50rem" : "0"}`,
        }}
        onClick={() => setAdRight(0)}
      >
        <span>
          N <br></br>e<br></br>w<br></br>s
        </span>
        <span
          className=" cursor-pointer position-absolute"
          style={{ height: "8px", width: "8px", left: "-8px", top: "1.5rem" }}
        >
          <i className="fa fa-caret-left fs-20 p-1 text-primary cursor-pointer  "></i>
        </span>
      </div> */}
    </BaseLayout>
  );
};
